module.exports = __webpack_public_path__ + "static/media/womens1.cf0814ee.jpg";